module.exports = __webpack_public_path__ + "img/joinUs_channel2.865a9bea.png";